import React, { useMemo } from "react";
import ReactEcharts from "echarts-for-react";

export default function CusDountChart({
  donutChartData,
  tooltipFormatter,
  labelShowDetail = false,
  labelDetail = [],
  radius = ["30%", "60%"],
  width = "100%",
  isShowLegend=true
}) {
  const options = useMemo(() => ({
    title: {
      left: "center",
      top: "center",
    },
    tooltip: tooltipFormatter ?? {},
    legend: {
      show:isShowLegend,
      left: "center",
      top: "bottom",
    },
    series: [
      {
        type: "pie",
        data: labelShowDetail
          ? donutChartData.map((chartData, index) => ({
              value: chartData.value,
              name: chartData.name,
              label: {
                formatter:
                  Array.isArray(labelDetail[index])
                    ? labelDetail[index].join("\n")
                    : chartData.name,
                backgroundColor: "#fff",
                borderColor: "#4b5563",
                borderWidth: 1,
                borderRadius: 4,
                rich: {
                  title: { color: "#fff", align: "center" },
                  abg: {
                    backgroundColor: "#4b5563",
                    width: "100%",
                    align: "right",
                    height: 25,
                    borderRadius: [4, 4, 0, 0],
                  },
                  text: {
                    align: "left",
                    padding: [3, 5],
                    fontSize: 14,
                  },
                  percent: {
                    align: "left",
                    padding: [3, 2],
                    fontSize: 14,
                  },
                },
                position: [10, 10],
              },
            }))
          : donutChartData,
        radius: radius,
      },
    ],
  }), [donutChartData, tooltipFormatter, labelShowDetail, labelDetail, radius]);

  return (
    <>
     <ReactEcharts
      option={options}
      style={{ height: "500px", width: width }}
    />
    </>
   
  );
}
